/* eslint-disable */
import { produce } from "immer";
import {
  HOME_FETCH_START,
  HOME_FETCH_SUCCESS,
  HOME_FETCH_FAILURE,
} from "../actions/types";

const home = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case HOME_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case HOME_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case HOME_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default home;
